import { Link } from 'react-router-dom';
import { cn } from '@strivelabs/ui-core/lib/utils';
import type { WorkflowExecution } from '@/hooks/useWorkflowExecutions';
import { titleOf } from '../../hooks/useChatList';
import { ChatRowMenu } from './ChatRowMenu';

export interface ChatRowProps {
  execution: WorkflowExecution;
  isActive: boolean;
  onRename: () => void;
  onDelete: () => void;
}

/**
 * One conversation. Presentational — the row takes callbacks rather than
 * mutations, so it can be rendered in a test without a QueryClient.
 */
export function ChatRow({ execution, isActive, onRename, onDelete }: ChatRowProps) {
  const title = titleOf(execution);

  return (
    <li className="group relative flex items-center">
      <Link
        to={`/ui/chat/${execution.id}`}
        aria-current={isActive ? 'page' : undefined}
        className={cn(
          // Right padding clears the action button, so a long title ends before
          // it rather than running underneath and truncating mid-glyph.
          'flex min-w-0 flex-1 items-center rounded-v2-md py-1 pl-2 pr-8 text-v2-base',
          'text-v2-sidebar-foreground transition-colors hover:bg-v2-sidebar-accent',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-sidebar-ring',
          isActive && 'bg-v2-sidebar-accent font-medium text-v2-sidebar-accent-foreground',
        )}
      >
        <span className="truncate">{title}</span>
      </Link>
      <span className="absolute right-1">
        <ChatRowMenu chatTitle={title} onRename={onRename} onDelete={onDelete} />
      </span>
    </li>
  );
}
